function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { gettext } from "web/script/modules/django-i18n";
import RetailerLink from "web/react/components/retailer-link/retailer-link";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { ShippingOptionPropType } from "web/types/buy-option";
import styles from "./price-info.css";
export function PriceInfo(_ref) {
  var currentPriceHtml = _ref.currentPriceHtml,
      formattedPrice = _ref.formattedPrice,
      isInStock = _ref.isInStock,
      isOnSale = _ref.isOnSale,
      leadUrl = _ref.leadUrl,
      retailerName = _ref.retailerName,
      selectedShipping = _ref.selectedShipping,
      retailAreaText = _ref.retailAreaText;

  // If it's out of stock, it's not on sale
  if (!isInStock) {
    isOnSale = false;
  }

  var shippingCostLabel = "";
  var guaranteedFreeShipping = false;

  if (selectedShipping) {
    if (selectedShipping.is_free) {
      guaranteedFreeShipping = true;
      shippingCostLabel = gettext("general.free_shipping");
    } else {
      shippingCostLabel = gettext("in_stock_product.shipping_cost", {
        shipping_cost: selectedShipping.formatted_price
      });
    }
  }

  return React.createElement("div", {
    className: styles.priceArea
  }, React.createElement("span", {
    className: styles.bothPrices
  }, React.createElement("span", {
    className: classnames(styles.price, _defineProperty({}, styles.oos, !isInStock)),
    dangerouslySetInnerHTML: {
      __html: currentPriceHtml
    }
  }), isOnSale && React.createElement("span", {
    className: styles.originalPrice
  }, " ", React.createElement("del", null, formattedPrice))), shippingCostLabel && React.createElement("span", {
    className: classnames(styles.shippingCost)
  }, guaranteedFreeShipping && React.createElement(SVGIcon, {
    name: "truck",
    className: styles.freeShippingIcon
  }), React.createElement("span", {
    className: styles.shippingCostLabel
  }, shippingCostLabel)), React.createElement("div", {
    className: styles.retailArea
  }, retailAreaText ? React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: retailAreaText
    }
  }) : React.createElement(RetailerLink, {
    retailerName: retailerName,
    leadUrl: leadUrl
  })));
}
PriceInfo.propTypes = {
  currentPriceHtml: PropTypes.string.isRequired,
  formattedPrice: PropTypes.string.isRequired,
  isInStock: PropTypes.bool,
  isOnSale: PropTypes.bool.isRequired,
  leadUrl: PropTypes.string.isRequired,
  retailerName: PropTypes.string,
  selectedShipping: ShippingOptionPropType,
  retailAreaText: PropTypes.string
};
PriceInfo.defaultProps = {
  isInStock: true
};
export default PriceInfo;